<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/admin/products" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Produkt bearbeiten - {{producerData !== null ? producerData.brand_name :''}}</h3>
      </div>
    </div>
    <div class="card-body">  
      <div class="listing-form-main">
        <ValidationObserver ref="newProductForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-10 form-div">
                <b-form-group id="fieldset-horizontal">
                  <span>Sie können noch weitere Bilder hochladen</span>
                  <vue-dropzone
                    name="productPictures"
                    ref="uploadProductImages"
                    id="example-input-0 dropzone"
                    :useCustomSlot="true"
                    :options="dropzoneOptions"
                    @vdropzone-file-added="(file) => uploadFile(file)"
                    @vdropzone-removed-file="handleRemoveImage"
                    aria-describedby="input-0-live-feedback"
                  >
                    <div class="dropzone dropzone-default" id="kt_dropzone_1">
                      <div class="dropzone-msg dz-message needsclick">
                        <h4>Bitte laden sie Produktbilder hoch</h4>
                        <h5>Dateien hierhin ziehen oder klicken zum Upload</h5>
                        <p>
                          Erlaubte Formate: JPEG, PNG
                          <br />Maximale Upload-Größe: 1MB
                        </p>
                      </div>
                    </div>
                  </vue-dropzone>
                </b-form-group>
                
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Product name is required.',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.productName"
                          :error-messages="errors[0]"
                          label="Produktname"
                          @input="getSlug(2, form.productName)"
                          outlined
                        ></v-text-field>
                        <!-- <span>{{ errors[0] }}</span> -->
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Produktkategorie ist erforderlich',
                        }"
                      >
                        <v-select
                          :items="categories"
                          v-model="form.productCategory"
                          :error-messages="errors[0]"
                          item-text="category_name"
                          item-value="id"
                          label="Produktkategorie"
                          outlined
                        />
                        <!-- <span>{{ errors[0] }}</span> -->
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <h6>Produktbeschreibung</h6>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Produktbeschreibung ist erforderlich',
                        }"
                      >
                        <!-- <vue-editor
                          placeholder="Produktbeschreibung"
                          :class="errors[0] ? 'error-outline' : ''"
                          v-model="form.productDescription"
                        ></vue-editor> -->
                        
                        <!-- {{form.productDescription}} -->
                        <!-- <ckeditor
                          v-model="form.productDescription"
                          :config="editorConfig"
                          @blur="getEditorData(form.productDescription)"
                        ></ckeditor> -->
                        <SummernoteEditor
                          v-model="form.productDescription"
                           :config="editorConfig"
                          @blur="getEditorData(form.productDescription)"
                        />
                        <span class="text-danger"
                          ><b>{{ errors[0] }}</b></span
                        >
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>

                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                    
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Einheit ist erforderlich',
                        }"
                      >
                        <v-select
                          :items="unitsList"
                          v-model="form.productUnit"
                          :error-messages="errors[0]"
                          item-text="unit"
                          item-value="id"
                          label="Einheit"
                          outlined
                        />
                        <!-- <span>{{ errors[0] }}</span> -->
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <v-select
                        :items="badges"
                        v-model="form.productBadge"
                        item-text="name"
                        item-value="id"
                        label="Abzeichen"
                        outlined
                        clearable
                      />
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>
                <!-- product feature -->
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <v-combobox
                        v-model="form.productFeatures"
                        :items="allProductFeatures"
                        label="Produkteigentschaften"
                        item-text="feature"
                        item-value="id"
                        multiple
                        outlined
                      ></v-combobox>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="age limit"
                        rules="min_value:0"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Das Alters-Limit muss 0 oder größer sein',
                        }"
                      >
                        <v-text-field
                          type="number"
                          autocomplete="new-password"
                          v-model="form.ageLimit"
                          :error-messages="errors[0]"
                          label="Alters-Limit"
                          min="0"
                          outlined
                        ></v-text-field>
                        <!-- <span>{{ errors[0] }}</span> -->
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <!-- <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Lieferbedingungen sind erforderlich',
                        }"
                      >
                        <v-combobox
                          v-model="form.deliveryOptions"
                          :items="allDeliveryOptions"
                          :error-messages="errors[0]"
                          label="Lieferbedingungen"
                          item-text="lable"
                          item-value="id"
                          multiple
                          outlined
                        ></v-combobox>
                      </ValidationProvider>
                    </b-form-group>
                  </div> -->
                </div>
                <v-divider></v-divider>
                <!-- end product feature -->
                
                <!-- Product Prices -->

                <div v-if='form.productPrices.length == 0'>
                  <div
                    class="row"
                    v-for="(pr, i) in firstProductPrices"
                    :key="'P' + i">
                    <div class="col-md-3">
                      <b-form-group id="fieldset-horizontal">
                        <ValidationProvider
                          rules="required|maxQuantity"
                          v-slot="{ errors }"
                          :custom-messages="{
                            required: 'Die Menge ist erforderlich',
                          }"
                        >
                          <v-text-field
                            autocomplete="new-password"
                            v-model="pr.quantity"
                            :error-messages="errors[0]"
                            label="Menge (laut Einheit)"
                            outlined
                          ></v-text-field>
                        </ValidationProvider>
                      </b-form-group>
                    </div>
                    <div class="col-md-4">
                      <b-form-group id="fieldset-horizontal">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :custom-messages="{
                            required: 'Lagerstand ist erforderlich',
                          }"
                        >
                          <v-text-field
                            type="number"
                            autocomplete="new-password"
                            v-model="pr.stock"
                            :error-messages="errors[0]"
                            label="Lagerstand"
                            outlined
                          ></v-text-field>
                        </ValidationProvider>
                      </b-form-group>
                    </div>
                    <div class="col-md-4">
                      <b-form-group id="fieldset-horizontal">
                        <ValidationProvider
                          name="product price"
                          rules="required|priceInput"
                          v-slot="{ errors }"
                          :custom-messages="{
                            required: 'Der Produktpreis (€) ist erforderlich',
                          }"
                        >
                          <v-text-field
                            autocomplete="new-password"
                            v-model="pr.price"
                            :error-messages="errors[0]"
                            label="Produktpreis (€)"
                            outlined
                          ></v-text-field>
                          <!-- <span>{{ errors[0] }}</span> -->
                        </ValidationProvider>
                      </b-form-group>
                    </div>
                    <div
                      v-if="i > 0"
                      class="col-md-1 plus-circle-btn removeService"
                    >
                      <a @click="removePrice(i)"
                        ><b-icon icon="x-circle"></b-icon
                      ></a>
                    </div>
                    <div class="col-md-1 plus-circle-btn" v-else>
                      <a @click="addPrice"
                        ><b-icon icon="plus-circle"></b-icon
                      ></a>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div
                    class="row"
                    v-for="(pr, i) in form.productPrices"
                    :key="'P' + i">
                    <div class="col-md-3">
                      <b-form-group id="fieldset-horizontal">
                        <ValidationProvider
                          rules="required|maxQuantity"
                          v-slot="{ errors }"
                          :custom-messages="{
                            required: 'Die Menge ist erforderlich',
                          }"
                        >
                          <v-text-field
                            autocomplete="new-password"
                            v-model="pr.quantity"
                            :error-messages="errors[0]"
                            label="Menge (laut Einheit)"
                            outlined
                          ></v-text-field>
                        </ValidationProvider>
                      </b-form-group>
                    </div>
                    <div class="col-md-4">
                      <b-form-group id="fieldset-horizontal">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :custom-messages="{
                            required: 'Lagerstand ist erforderlich',
                          }"
                        >
                          <v-text-field
                            type="number"
                            autocomplete="new-password"
                            v-model="pr.stock"
                            :error-messages="errors[0]"
                            label="Lagerstand"
                            min="0"
                            outlined
                          ></v-text-field>
                        </ValidationProvider>
                      </b-form-group>
                    </div>
                    <div class="col-md-4">
                      <b-form-group id="fieldset-horizontal">
                        <ValidationProvider
                          name="product price"
                          rules="required|priceInput"
                          v-slot="{ errors }"
                          :custom-messages="{
                            required: 'Der Produktpreis (€) ist erforderlich',
                          }"
                        >
                          <v-text-field
                            autocomplete="new-password"
                            v-model="pr.price"
                            :error-messages="errors[0]"
                            label="Produktpreis (€)"
                            outlined
                          ></v-text-field>
                          <!-- <span>{{ errors[0] }}</span> -->
                        </ValidationProvider>
                      </b-form-group>
                    </div>
                    <div
                      v-if="i > 0"
                      class="col-md-1 plus-circle-btn removeService"
                    >
                      <a @click="removePrice(i)"
                        ><b-icon icon="x-circle"></b-icon
                      ></a>
                    </div>
                    <div class="col-md-1 plus-circle-btn" v-else>
                      <a @click="addPrice"
                        ><b-icon icon="plus-circle"></b-icon
                      ></a>
                    </div>
                  </div>
                </div>
             
                <v-divider></v-divider>
                <!-- end Product Prices -->
                <!-- Product Information -->
                <div
                  class="row"
                  v-for="(info, i) in form.productInformations"
                  :key="i">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <v-autocomplete
                        v-model="info.infoId"
                        :items="informations"
                        outlined
                        item-text="lable"
                        item-value="id"
                        label="Produktinformation"
                        clearable
                      ></v-autocomplete>
                    </b-form-group>
                  </div>
                  <div class="col-md-5">
                    <b-form-group id="fieldset-horizontal">
                      <v-select
                        :items="infoValues"
                        v-model="info.value"
                        item-text="lable"
                        item-value="value"
                        label="Wert (Ja/Nein)"
                        outlined
                        clearable
                      />
                    </b-form-group>
                  </div>
                  <div
                    v-if="i > 0"
                    class="col-md-1 plus-circle-btn removeService"
                  >
                    <a @click="removeInformation(i)"
                      ><b-icon icon="x-circle"></b-icon
                    ></a>
                  </div>
                  <div class="col-md-1 plus-circle-btn" v-else>
                    <a @click="addInformation"
                      ><b-icon icon="plus-circle"></b-icon
                    ></a>
                  </div>
                </div>
                <!-- end product information -->
              
                <!-- end state -->
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        type="number"
                        rules="required|priceInput"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der MWSt. (%) ist erforderlich',
                          min_value: 'Die MWSt. (%) muss 0 oder größer sein',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.vatPercent"
                          :error-messages="errors[0]"
                          label="MWSt. (%)"
                          outlined
                        ></v-text-field>
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6"></div>
                </div>
                <!-- Meta description added -->
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required|max160"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="form.productMetaDescription"
                          label="Produkt Meta Beschreibung für SEO (max. 160 Zeichen, Standard: Produkt Beschreibungstext)"
                          :error-messages="errors[0]"
                          maxlength="160"
                          outlined
                          @blur="restorePopUp(e=1)"
                        ></v-text-field>
                      <span class="text-danger" v-if="form.productMetaDescription && form.productMetaDescription.length > 160">{{ errors[0] }}</span>
                      </ValidationProvider>    
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group>
                      <ValidationProvider
                        rules="required|max50"
                        v-slot="{ errors }"
                      >  
                      <v-text-field
                          v-model="form.productMetaTitle"
                          :error-messages="errors[0]"
                          label="Produkt Meta Name für SEO (max. 50 Zeichen, Standard: Produkt Name)"
                          outlined
                          @blur="restorePopUp(e=2)"
                        ></v-text-field>
                        <span class="text-danger" v-if="form.productMetaTitle && form.productMetaTitle.length > 50">{{ errors[0] }}</span>
                      </ValidationProvider>  
                    </b-form-group>
                  </div>
                  <div class="col-md-6">

                  </div>
                </div>
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                      >
                      <v-text-field
                          v-model="form.productCanonicalLink"
                          label="Produkt Canonical Link für SEO (Standard: Produkt URL)"
                          :error-messages="errors[0]"
                          outlined
                          @blur="restorePopUp(e=3)"
                        ></v-text-field>
                      </ValidationProvider>   
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                      >
                      <v-select
                          :items="robotValues"
                          v-model="form.productMetaRobot"
                          item-text="lable"
                          item-value="value"
                          :error-messages="errors[0]"
                          label="Produkt Meta Robots Einstellung für SEO (Standard: index, follow)"
                          outlined clearable
                        />
                      </ValidationProvider>     
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>                

                <div class="fo-row-btn text-right">
                  <v-btn class="submit-btn-fill-outline" @click="goToBack">
                    Abbrechen
                  </v-btn>
                  <v-btn
                    type="button"
                    :disabled="isDraftDisabled"
                    ref="kt_form_submit_btn"
                    @click="saveDraft()"
                    class="submit-btn-fill-outline"
                  >
                    {{ draftText }}
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
        <v-dialog v-model="statusDialog" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2">
              Bitte bestätigen
            </v-card-title>
            <v-card-text>
              <span>Möchten Sie den Wert wiederherstellen?</span>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn
                class="no-button"
                @click="hideModal"
              >
                Nein
              </v-btn>
              <v-btn
                type="submit"
                @click="restore()"
                ref="kt_form_submit_btn"
                class="yes-button"
              >
                Ja
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- <v-dialog v-model="UpdateDialogbox" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2">
              Bitte bestätigen
            </v-card-title>

            <v-card-text>
              <span>Wir haben unseren Editor kürzlich aktualisiert! Bitte überprüfen Sie Ihre Produktbeschreibung auf dieser Seite und nehmen Sie gegebenenfalls Anpassungen vor.</span>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn
                class="no-button"
                @click="hideModal"
              >
                Nein
              </v-btn>
              <v-btn
                type="submit"
                @click="descriptionUpdateBox()"
                ref="kt_form_submit_btn"
                class="yes-button"
              >
                Ja
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
      </div>
    </div>
    <notifications group="products" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import vue2Dropzone from "vue2-dropzone";
import HtmlClass from "@/core/services/htmlclass.service";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import config from "@/config/app";
import adminAPI from "@/api/admin";
import providerAPI from "@/api/provider";
// import { VueEditor, Quill } from "vue2-editor";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import SummernoteEditor from '@/components/admin/pages/product/adminProduct/SummernoteEditor.vue';
Vue.use(Notifications);

import { extend } from "vee-validate";

import CKEditor from "ckeditor4-vue";

Vue.use(CKEditor);
//-------
// import { VueEditor } from "vue2-editor";
// import { ImageDrop } from "quill-image-drop-module";
// import { ImageResize as OriginalImageResize } from "quill-image-resize-module";


// Extend or Override the ImageResize module
// class CustomImageResize extends OriginalImageResize {
//   hideSizeDisplay() {
//     if (this.sizeDisplay && this.sizeDisplay.parentNode) {
//       try {
//         this.sizeDisplay.parentNode.removeChild(this.sizeDisplay);
//       } catch (e) {
//         console.error("Failed to remove size display:", e);
//       }
//     } else {
//       console.warn('Size display element is not found or already removed.');
//     }
//   }
// }
//-----------------
//------
import metarobots from "@/config/constant";

extend("max160", {
  message: (field) => "Produkt Meta Beschreibung: maximal 160 Zeichen",
  validate: (value) => {
    var regx = /^.{0,160}$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

extend("max50", {
  message: (field) => "Produkt Meta Name: maximal 50 Zeichen",
  validate: (value) => {
    var regx = /^.{0,50}$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

extend("priceInput", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^[0-9.,]+$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

extend("maxQuantity", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^[1-9000.,]+$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

export default {
  name: "EditProduct",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      const categoryPromise = this.getCategories();
      const paymentOptionsPromise = this.getPaymentOptions();
      const infoPromise = this.getInformation();
      const ProducerPromise = this.getActiveProducers();
      const badgePromise = this.getActiveBadges();
      this.infoValues = this.getInfoValues();
      this.robotValues = metarobots; //this.getRobotValues();
      const productFeaturesPromise = this.getProductFeatures();
      // const productCertificatePromise = this.getProductCertificates();
      // const deliveryOptionsPromise = this.getDeliveryOptions();
      const unitsPromise = this.getProductUnits();
      const productPromise = this.getProductData();

      Promise.all([
        categoryPromise,
        paymentOptionsPromise,
        infoPromise,
        ProducerPromise,
        badgePromise,
        productFeaturesPromise,
        // deliveryOptionsPromise,
        unitsPromise,
        productPromise,
      ]).then(() => {});
    }
    if(this.form.productMetaRobot ==''|| this.form.productMetaRobot == null || this.form.productMetaRobot == undefined){
        this.form.productMetaRobot = this.robotValues[0].value
    }
  },
  components: {
    vueDropzone: vue2Dropzone,
    SummernoteEditor
  },
  data() {
    return {
      UpdateDialogbox:false,
      UpdateDialogStatus:false,
      buttonStatus:'',
      color: '#f05454',
      size: '20px', 
      dropzoneOptions: {
        url: config.API_URL + "add-product",
        thumbnailWidth: 150,
        maxFilesize: 1,
        maxFiles: 10,
        addRemoveLinks: true,
        autoProcessQueue: false,
        timeout: 20000000,
        acceptedFiles: ".jpeg, .jpg, .png",
        uploadMultiple: true,
        headers: { Authorization: `Bearer ${JwtService.getToken()}` },
      },
      editorConfig: {
        language: 'de',scayt_sLang : 'de_DE'
      },
      // customModulesForEditor: [
      //   { alias: "imageDrop", module: ImageDrop },
      //   { alias: "imageResize", module: CustomImageResize  }
      // ],
      // editorConfig: {
      //   language: 'de',scayt_sLang : 'de_DE',
      //   modules: {
      //     imageDrop: true,
      //     imageResize: {}
      //   }
      // },
      submitText: "Abschicken",
      draftText: "Als Entwurf speichern",
      formError: false,
      userId: null,
      formData: [],
      categories: [],
      infoValues: [],
      robotValues: [],
      producerData: [],
      badges: [],
      unitsList: [],
      paymentOptions: [],
      allProductFeatures: [],
      allProductCertificates: [],
      // allDeliveryOptions: [],
      informations: [],
      statesList: [],
      providers: [],
      imageChanged: "0",
      currentImage: null,
      btnDisable: false,
      btnDraftDisable: false,
      submitStatus: null,
      acceptImageLength: 4,
      old_product_status: "",
      oldImages: [],
      firstProductPrices: [
          {
            quantity: 1,
            price: "",
            stock: ""
          },
        ],
      form: {
        productImages: [],
        productName: "",
        productDescription: "",
        productCategory: "",
        productPrice: "",
        ageLimit: 0,
        productBadge: "",
        productUnit: "",
        productPayOption: "",
        productFeatures: [],
        // productCertificates: [],
        // deliveryOptions: [],
        producer: "",
        productInformations: [],
        productPrices:[],        
        vatPercent: 0,
        productMetaDescription:"",
        productMetaTitle: "",
        productCanonicalLink: "",
      },
      brand_name:'',
      brand_name_slug:'',
      product_name_slug:'',
      autoUpdate:false,
      statusDialog: false,
      restoreField:null,
      restore_meta_description:false
    };
  },
  watch: {
    "form.productName": function (value) {
      if (this.autoUpdate) {
        this.form.productMetaTitle = value.substr(0, 50)
      }
    },
  },
  methods: {
    descriptionUpdateBox(){
      this.UpdateDialogStatus = true;
      this.UpdateDialogbox = false;
      if (this.buttonStatus == '1') {
        this.saveDraft();
      } else if (this.buttonStatus == '2') {
        this.onSubmit();
      }
    },
    getInformation() {
      adminAPI
        .getProductInfo()
        .then((response) => {
          if (response.status == "success") {
            this.informations = response.data;
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },

    getPaymentOptions() {
      adminAPI
        .getPaymentOptions()
        .then((response) => {
          if (response.status == "success") {
            this.paymentOptions = response.data;
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    getGeneralSettings(provider_id) {
      adminAPI
        .getGeneralSettings({ id: provider_id })
        .then((response) => {
          if (response.status == "success") {
              
              if (
                response.data.tax &&
                response.data.is_vat_zero_to_all_products === "0"
              ) {
                this.form.vatPercent = response.data.tax;
              } else {
                this.idVatReadonly = true;
                this.form.vatPercent = 0;
              }
              if(response.producer_data){
                this.brand_name = response.producer_data.brand_name;
                this.getSlug(1,this.brand_name)
                // console.log('brnad-name', response.producer_data.brand_name)
              }
          } 
        })
        .catch((err) => {
          this.btnDisable = false;
          this.submitText = "Abschicken";
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 5000,
          });
        });
    },
    getProductFeatures() {
      adminAPI
        .getProductFeatures()
        .then((response) => {
          if (response.status == "success") {
            this.allProductFeatures = response.data;
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    getProductUnits() {
      adminAPI
        .getProductUnits()
        .then((response) => {
          if (response.status == "success") {
            this.unitsList = response.data;
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    // getDeliveryOptions() {
    //   adminAPI
    //     .getDeliveryOptions()
    //     .then((response) => {
    //       if (response.status == "success") {
    //         this.allDeliveryOptions = response.data;
    //       } else {
    //         this.$notify({
    //           group: "products",
    //           type: "error",
    //           position: "bottom right",
    //           text: response.msg,
    //           duration: 3000,
    //         });
    //       }
    //     })
    //     .catch((err) => {
    //       this.$notify({
    //         group: "products",
    //         type: "error",
    //         position: "bottom right",
    //         text: err,
    //         duration: 3000,
    //       });
    //     });
    // },

    getActiveBadges() {
      adminAPI
        .getActiveBadges()
        .then((response) => {
          if (response.status == "success") {
            this.badges = response.data;
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },

    getInfoValues() {
      return [
        {
          lable: "Ja",
          value: "Ja",
        },
        {
          lable: "Nein",
          value: "Nein",
        },
      ];
    },
    addInformation() {
      this.form.productInformations.push({
        infoId: "",
        value: "",
      });
    },
    removeInformation(i) {
      this.form.productInformations.splice(i, 1);
    },

    addPrice() {
      this.form.productPrices.push({
        quantity: "",
        price: "",
        stock: ""
      });
    },
    removePrice(i) {
      this.form.productPrices.splice(i, 1);
    },
    goToBack() {
      this.$router.push({ name: "products" });
    },
    getCategories() {
      adminAPI
        .activeCategory()
        .then((response) => {
          if (response.status == "success") {
            this.categories = response.data;
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    getActiveProducers() {
      axios
        .get("active-producers")
        .then((response) => {
          var responseJson = response.data;
          if (responseJson.status == "success") {
            this.providers = responseJson.data;
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: responseJson.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    uploadFile(file) {
      setTimeout(() => {
        if (file.status == "queued") {
          this.form.productImages.push(file);
        }
      }, 500);
    },
    handleRemoveImage(file) {
      var array = this.oldImages.filter((elm) => elm.photo_name !== file.name);
      this.oldImages = array;
    },

    getProductData() {
      axios
        .post("edit-product", { id: this.$route.params.id })
        .then(async (response) => {
          var responseJson = response.data.data;
          if (response.data.status == "success") {
            this.form.productName = responseJson.product_name;
            this.form.productDescription = responseJson.description;
            this.form.productPrice = responseJson.product_prices;
            this.productPrice = responseJson.product_prices;
            this.form.ageLimit = responseJson.age_limit;
            this.form.producer = responseJson.producer_id;
            this.producerData = responseJson.producer_details;
            this.brand_name = this.producerData ? this.producerData.brand_name :''
            if (this.brand_name) {
              await this.getSlug(1, this.brand_name)
            }
            this.old_product_status = responseJson.is_status;
            this.form.vatPercent = responseJson.vat;

            this.form.productMetaDescription = responseJson.meta_description ?? "";
            
            if(this.form.productMetaDescription ==''|| this.form.productMetaDescription == null || this.form.productMetaDescription == undefined){
              this.restore_meta_description = true;
              responseJson.description ? this.getEditorData(responseJson.description) :''
              
            }else{
              localStorage.setItem("productMetaDescription",this.form.productMetaDescription)
            }
            this.form.productMetaTitle = responseJson.title ?? "";
            if(this.form.productMetaTitle ==''|| this.form.productMetaTitle == null || this.form.productMetaTitle == undefined){
                this.form.productMetaTitle = responseJson.product_name
            }
            this.form.productCanonicalLink = responseJson.canonical_link ?? "";
            if(this.form.productCanonicalLink ==''|| this.form.productCanonicalLink == null || this.form.productCanonicalLink == undefined){
              await this.getSlug(2, this.form.productName)
            }
            this.form.productMetaRobot = responseJson.meta_robots;
            if(this.form.productMetaRobot ==''|| this.form.productMetaRobot == null || this.form.productMetaRobot == undefined){
                this.form.productMetaRobot = this.robotValues[0].value
            }

            if (this.form.productName == this.form.productMetaTitle) {
                this.autoUpdate = true;
            }
            
            
            if (responseJson.badge != null) {
              this.form.productBadge = responseJson.badge.badge_id;
            }
            if (responseJson.unit_detail) {
              this.form.productUnit = responseJson.unit_detail.id;
            }

            if (responseJson.pictures.length) {
              this.form.file = responseJson.pictures[0].photo_name;
              this.currentImage = responseJson.pictures[0].photo_path;
            }

            if (responseJson.product_informations.length) {
              responseJson.product_informations.forEach((item) => {
                this.form.productInformations.push({
                  infoId: item.information_id,
                  value: item.value,
                });
              });
            } else {
              this.form.productInformations.push({
                infoId: "",
                value: "",
              });
            }
            if (responseJson.product_prices.length) {
              responseJson.product_prices.forEach((item) => {
                this.form.productPrices.push({
                  quantity: item.unit_quantity,
                  price: item.price,
                  stock: item.stock
                });
              });
            } else {
              this.form.productPrices.push({
                quantity: "",
                price: "",
                stock: ""
              });
            }

            if (responseJson.category.length) {
              responseJson.category.forEach((item) => {
                this.form.productCategory = item.category_id;
              });
            } else {
              this.form.productCategory = "";
            }
            if (responseJson.features.length) {
              responseJson.features.forEach((item) => {
                this.form.productFeatures.push({
                  feature: item.product_feature_detail.feature,
                  id: item.feature_id,
                });
              });
            }
            // if (responseJson.delivery_options.length) {
            //   responseJson.delivery_options.forEach((item) => {
            //     this.form.deliveryOptions.push({
            //       lable: item.product_delivery_option.lable,
            //       id: item.delivery_option_id,
            //     });
            //   });
            // }
            this.acceptImageLength = 4 - responseJson.pictures.length;
            this.oldImages = responseJson.pictures;
            responseJson.pictures.forEach((item, i) => {
              if (
                item.photo_path.indexOf(".jpg") !== -1 ||
                item.photo_path.indexOf(".jpeg") !== -1
              ) {
                var file = {
                  size: 12345,
                  name: item.photo_name,
                  type: "image/jpeg",
                };
                this.$refs.uploadProductImages.manuallyAddFile(
                  file,
                  item.photo_path
                );
              }
              if (item.photo_path.indexOf(".png") !== -1) {
                var file = {
                  size: 12345,
                  name: item.photo_name,
                  type: "image/png",
                };
                this.$refs.uploadProductImages.manuallyAddFile(
                  file,
                  item.photo_path
                );
              }
            });
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
        
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: responseJson.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");  
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    saveDraft() {
      // if (this.UpdateDialogStatus) {
      if (this.form.productName) {
        this.btnDisable = true;
        this.btnDraftDisable = true;
        this.draftText = "Wird gespeichert...";
        this.submitStatus = "0";
        // this.form.productDescription = this.form.productDescription.split('<p></p>').join('');
        let formData = new FormData();
        formData.append("id", this.$route.params.id);
        formData.append("user_id", this.currentUser.id);
        formData.append("product_name", this.form.productName);
        formData.append("product_description", this.form.productDescription ?? '');
        formData.append("product_category", this.form.productCategory);
        //formData.append("age_limit", this.form.ageLimit);
        let productAgeLimit = 0;
        if (this.form.ageLimit > 0) productAgeLimit = this.form.ageLimit;

        formData.append("age_limit", productAgeLimit);
        formData.append("badge_id", this.form.productBadge);
        formData.append("unit_id", this.form.productUnit);
        formData.append("product_status", this.submitStatus);
        formData.append("producer_id", this.form.producer);
        formData.append("old_product_status", this.old_product_status);
        let productVatPercent = 0;
          if (this.form.vatPercent > 0)
            productVatPercent = this.form.vatPercent;
          formData.append("product_vat", productVatPercent);
        // BY DEFAULT SET CREDIT CARD OPTION
        formData.append("payment_option", 1);
        const features = [];
        for (var i = 0; i < this.form.productFeatures.length; i++) {
          features.push(this.form.productFeatures[i].id);
        }
        formData.append("product_features", JSON.stringify(features));
        // const delOptions = [];
        // for (var i = 0; i < this.form.deliveryOptions.length; i++) {
        //   delOptions.push(this.form.deliveryOptions[i].id);
        // }
        // formData.append("delvery_options", JSON.stringify(delOptions));
        formData.append("image_changed", this.imageChanged);
        //formData.append("file", this.form.file);
        for (var i = 0; i < this.form.productImages.length; i++) {
          formData.append("file[" + i + "]", this.form.productImages[i]);
        }
        var oldFiles = [];
        for (var i = 0; i < this.oldImages.length; i++) {
          oldFiles.push(this.oldImages[i].photo_name);
        }
        formData.append("old_file", oldFiles);

        formData.append(
          "product_informations",
          JSON.stringify(this.form.productInformations)
        );
        // console.log(JSON.stringify(this.firstProductPrices))
        if(this.form.productPrices.length > 0){
          formData.append(
          "product_prices",
          JSON.stringify(this.form.productPrices)
          );
        } else{
          formData.append(
          "product_prices",
          JSON.stringify(this.firstProductPrices)
          );
        }
        

        setTimeout(() => {
          axios
            .request({
              method: "POST",
              url: "/update-product",
              mimeType: "multipart/form-data",
              data: formData,
            })
            .then((response) => {
              if (response.data.status == "success") {
                this.btnDisable = false;
                this.btnDraftDisable = false;
                this.draftText = "Als Entwurf speichern";
                this.$notify({
                  group: "products",
                  type: "success",
                  position: "bottom right",
                  text: response.data.msg,
                  duration: 5000,
                });
                setTimeout(() => {
                  this.$router.push({ name: "products" });
                }, 2000);
              } else {
                this.btnDisable = false;
                this.btnDraftDisable = false;
                this.draftText = "Als Entwurf speichern";
                this.$notify({
                  group: "products",
                  type: "error",
                  position: "bottom right",
                  text: response.data.msg,
                  duration: 5000,
                });
              }
            })
            .catch((err) => {
              this.btnDisable = false;
              this.btnDraftDisable = false;
              this.draftText = "Als Entwurf speichern";
              this.$notify({
                group: "products",
                type: "error",
                position: "bottom right",
                text: err,
                duration: 5000,
              });
            });
        }, 2000);
      } else {
        this.$notify({
          group: "products",
          type: "error",
          position: "bottom right",
          text: "Bitte geben Sie den Namen der Unterkunft ein, um ihn als Entwurf zu speichern.",
          duration: 5000,
        });
      }
      // } else {
      //   this.buttonStatus = '1';
      //   this.UpdateDialogbox = true;
      // }
    },

    onSubmit() {
      // console.log(this.form.productDescription)
      
      // console.log(str);
      // if (this.UpdateDialogStatus) {
        this.$refs.newProductForm.validate().then((success) => {
          if (success && this.form.file !== null) {
            this.btnDisable = true;
            this.btnDraftDisable = true;
            this.submitText = "Wird abgeschickt...";
            this.submitStatus = "2";

            let formData = new FormData();
            // this.form.productDescription = this.form.productDescription.split('<p></p>').join('');
            formData.append("id", this.$route.params.id);
            formData.append("user_id", this.currentUser.id);
            formData.append("product_name", this.form.productName);
            formData.append("product_description", this.form.productDescription);
            formData.append("product_category", this.form.productCategory);
            formData.append("meta_description", this.form.productMetaDescription ?? "");
            formData.append("title", this.form.productMetaTitle ?? "");
            formData.append("canonical_link", this.form.productCanonicalLink ?? "");
            formData.append("meta_robots", this.form.productMetaRobot);

            //formData.append("age_limit", this.form.ageLimit);
            let productAgeLimit = 0;
            if (this.form.ageLimit > 0) productAgeLimit = this.form.ageLimit;

            formData.append("age_limit", productAgeLimit);
            formData.append("badge_id", this.form.productBadge);
            formData.append("unit_id", this.form.productUnit);
            formData.append("producer_id", this.form.producer);
            formData.append("product_status", this.old_product_status == 0 ? this.submitStatus : this.old_product_status);
            formData.append("old_product_status", this.old_product_status);
            //formData.append("payment_option", this.form.productPayOption);
            // BY DEFAULT SET CREDIT CARD OPTION
            formData.append("payment_option", 1);
            const features = [];
            for (var i = 0; i < this.form.productFeatures.length; i++) {
              features.push(this.form.productFeatures[i].id);
            }
            formData.append("product_features", JSON.stringify(features));

            // const certificates = [];
            // for (var i = 0; i < this.form.productCertificates.length; i++) {
            //   certificates.push(this.form.productCertificates[i].id);
            // }
            // formData.append("product_certificates", JSON.stringify(certificates));

            // const delOptions = [];
            // for (var i = 0; i < this.form.deliveryOptions.length; i++) {
            //   delOptions.push(this.form.deliveryOptions[i].id);
            // }
            // formData.append("delvery_options", JSON.stringify(delOptions));
            formData.append("image_changed", this.imageChanged);
            //formData.append("file", this.form.file);
            for (var i = 0; i < this.form.productImages.length; i++) {
              formData.append("file[" + i + "]", this.form.productImages[i]);
            }
            var oldFiles = [];
            for (var i = 0; i < this.oldImages.length; i++) {
              oldFiles.push(this.oldImages[i].photo_name);
            }
            formData.append("old_file", oldFiles);

            let productVatPercent = 0;
            if (this.form.vatPercent > 0)
              productVatPercent = this.form.vatPercent;
            formData.append("product_vat", productVatPercent);

            formData.append(
              "product_informations",
              JSON.stringify(this.form.productInformations)
            );

            // formData.append(
            //   "state_informations",
            //   JSON.stringify(this.form.stateInformations)
            // );
            formData.append(
              "product_prices",
              JSON.stringify(this.form.productPrices)
            );
            setTimeout(() => {
              axios
                .request({
                  method: "POST",
                  url: "/update-product",
                  mimeType: "multipart/form-data",
                  data: formData,
                })
                .then((response) => {
                  if (response.data.status == "success") {
                    this.btnDisable = false;
                    this.btnDraftDisable = false;
                    this.submitText = "Abschicken";
                    this.$notify({
                      group: "products",
                      type: "success",
                      position: "bottom right",
                      text: response.data.msg,
                      duration: 5000,
                    });
                    setTimeout(() => {
                      this.$router.push({ name: "products" });
                    }, 2000);
                  } else {
                    this.btnDisable = false;
                    this.btnDraftDisable = false;
                    this.submitText = "Abschicken";
                    this.$notify({
                      group: "products",
                      type: "error",
                      position: "bottom right",
                      text: response.data.msg,
                      duration: 5000,
                    });
                  }
                })
                .catch((err) => {
                  this.btnDisable = false;
                  this.btnDraftDisable = false;
                  this.submitText = "Abschicken";
                  this.$notify({
                    group: "products",
                    type: "error",
                    position: "bottom right",
                    text: err,
                    duration: 5000,
                  });
                });
            }, 2000);
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: 'fehlender obligatorischer Wert oder falsches Format',
              duration: 5000,
            });
            this.btnDisable = false;
            this.btnDraftDisable = false;
          }
        });
      // } else {
      //   this.buttonStatus = '2';
      //   this.UpdateDialogbox = true;
      // }
    },
    getSlug(id, name) {
      if (name && id){
        adminAPI
        .createSlug({ name: name })
        .then((response) => {
          if (response.status == "success") {
              // console.log('createSlug', response)
              if ( id == 1){
                var b_slug = response.data.slug
                this.brand_name_slug = b_slug.substr(0, 15)
              } else {
                this.product_name_slug = response.data.slug
                if (this.autoUpdate) {
                  // this.form.productMetaTitle = name.substr(0, 50)
                }
              }

              console.log('hostname', window.location.hostname)

              if(this.product_name_slug && this.brand_name_slug) {
                if (window.location.hostname == 'stage.gustoreich.at' || window.location.hostname == 'localhost') {
                  this.form.productCanonicalLink = 'https://stage.gustoreich.at/produkt/'+this.product_name_slug+'_' + this.brand_name_slug
                } else {
                  this.form.productCanonicalLink = 'https://gustoreich.at/produkt/'+this.product_name_slug+'_' + this.brand_name_slug
                }  
              }
          } 
        }).catch((err) => {
            console.log(err)
        });
      }
    },
    getEditorData(htmlData) {
      htmlData = htmlData.replace(/<\/p>/g, '</p> '); 
      const tempElement = document.createElement('div');
      tempElement.innerHTML = htmlData;
      const plainText = tempElement.textContent;
      var removeEnter = plainText.replace(/\r?\n|\r/g, ' ');
      var removeSpace = removeEnter.replace(/\s{2,}/g, ' ');
      this.form.productMetaDescription = removeSpace.substr(0,160);
      if(this.restore_meta_description){
        localStorage.setItem("productMetaDescription",this.form.productMetaDescription)
      }
      // console.log(plainText);
    },
    restorePopUp(e){
      console.log('<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<',localStorage.getItem('productMetaDescription'))
      if((e=='1') && (!this.form.productMetaDescription)&& (localStorage.getItem('productMetaDescription'))){
        this.restoreField = e;
        this.statusDialog = true;
      }else if((e=='2') && (!this.form.productMetaTitle) && (this.form.productName) && (this.autoUpdate)){
        this.restoreField = e;
        this.statusDialog = true;
      }else if((e=='3') && (!this.form.productCanonicalLink) && (this.brand_name) && (this.form.productName)){
        this.restoreField = e;
        this.statusDialog = true;
      }
      
    },
    hideModal(){
      this.statusDialog = false
      this.UpdateDialogbox = false;
      this.UpdateDialogStatus = false;
    },
    async restore(){
      if(this.restoreField == '1') {
        // this.getEditorData(this.form.productDescription)
        this.form.productMetaDescription = localStorage.getItem('productMetaDescription');
      }else if(this.restoreField == '2') {
        this.form.productMetaTitle = this.form.productName.substring(0,50);
      }else if(this.restoreField == '3') {
       await this.getSlug(1,this.brand_name);
       await this.getSlug(2, this.form.productName);
      }
      this.statusDialog = false
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },

    isDisabled: function () {
      return this.btnDisable;
    },
    isDraftDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.form-div {
  margin: auto;
}

.form-errors {
  color: red;
}

.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.draft-button {
  background-color: #ff9419 !important;
}

.draft-button:hover {
  background-color: #e57a00 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}

.mx-datepicker {
  width: 100% !important;
}
</style>
